<template>
  <div class="row justify-content-center">
    <!-- User Profile Card -->
    <div class="col-md-8">
      <CCard>
        <CCardHeader class="bg-primary text-white font-weight-bold d-flex justify-content-between align-items-center">
          <span><CIcon name="cil-user" /> Mis Datos</span>
          <button @click="goBack" type="button" class="btn btn-sm text-white" style="background: #E46666">
              <i class="fas fa-arrow-left"></i> Retroceder
          </button>
        </CCardHeader>
        <CCardBody>
          <form @submit.prevent="updateProfile">
            <CRow>
              <CCol sm="6">
                <CInput
                  label="DNI"
                  v-model="user.dni"
                  maxlength="8"
                  readonly
                  disabled
                >
                  <template #prepend-content><CIcon name="cil-credit-card"/></template>
                </CInput>
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Email"
                  v-model="user.email"
                  type="email"
                  required
                >
                  <template #prepend-content><CIcon name="cil-envelope-open"/></template>
                </CInput>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Nombres"
                  v-model="user.name"
                  required
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Apellidos"
                  v-model="user.last_name"
                  required
                >
                   <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
              </CCol>
            </CRow>

            <div class="form-actions mt-3">
              <CButton type="submit" color="primary" class="px-4">Actualizar Datos</CButton>
              <CButton color="warning" class="px-4 ml-2" @click="openPasswordModal">Cambiar Contraseña</CButton>
            </div>
          </form>
        </CCardBody>
      </CCard>
    </div>

    <!-- Password Modal -->
    <CModal
      title="Cambiar Contraseña"
      :show.sync="passwordModal"
      color="warning"
      centered
    >
      <form @submit.prevent="updatePassword">
        <CInput
          label="Nueva Contraseña"
          type="password"
          v-model="passwordForm.password"
          placeholder="Ingrese nueva contraseña"
          required
        />
        <!-- <CInput
          label="Confirmar Contraseña"
          type="password"
          v-model="passwordForm.password_confirmation"
          placeholder="Repita la contraseña"
          required
        /> -->
      </form>
      <template #footer>
        <CButton @click="passwordModal = false" color="secondary">Cancelar</CButton>
        <CButton @click="updatePassword" color="warning">Guardar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Profile",
  data() {
    return {
      user: {
        id: "",
        name: "",
        last_name: "",
        dni: "",
        email: "",
        // Add other fields if necessary for consistency with backend expectation
        document_type: "DNI",
        rol_id: "",
        company_id: "",
      },
      passwordModal: false,
      passwordForm: {
        id: "",
        password: "",
      },
    };
  },
  created() {
    this.loadUserData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    loadUserData() {
      // Load from store first, but ideally should fetch fresh data
      const storeUser = this.$store.getters.get_all_user;
      
      // Fetch fresh data to be sure
      this.get({
        url: this.$store.getters.get__url + "/users/" + storeUser.id + "/show",
        token: this.$store.getters.get__token,
      })
      .then((response) => {
        this.user = {
            ...response.data,
            // Ensure fields are mapped correctly if backend response differs
        };
        // Setup password form ID
        this.passwordForm.id = this.user.id || this.user.Id;
      })
      .catch((error) => {
        console.error("Error loading user data", error);
        // Fallback to store data
        this.user = { ...storeUser };
        this.passwordForm.id = this.user.id;
      });
    },
    updateProfile() {
      // Adapt payload to what 'users/update' expects
      // Looking at `users.vue`: `params: this.users`
      
      this.post({
        url: this.$store.getters.get__url + "/users/update",
        token: this.$store.getters.get__token,
        params: this.user,
      })
      .then((response) => {
        Swal.fire({
          title: "Datos Actualizados",
          text: "Su información ha sido actualizada correctamente.",
          icon: "success",
        });
        // Update user in store if necessary, or trigger a reload
        // Typically need to commit mutation to update store user
        // this.$store.commit('update_user', this.user); // Assuming such mutation exists
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No se pudo actualizar la información.",
          icon: "error",
        });
        console.error(error);
      });
    },
    openPasswordModal() {
      this.passwordModal = true;
      this.passwordForm.password = "";
    },
    updatePassword() {
      if (!this.passwordForm.password) {
        Swal.fire("Error", "Debe ingresar una contraseña", "warning");
        return;
      }

      this.post({
        url: this.$store.getters.get__url + "/users/new_password",
        token: this.$store.getters.get__token,
        params: this.passwordForm,
      })
      .then((response) => {
        this.passwordModal = false;
        Swal.fire({
          title: "Contraseña Actualizada",
          text: "Su contraseña ha sido cambiada exitosamente.",
          icon: "success",
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No se pudo cambiar la contraseña.",
          icon: "error",
        });
      });
    },
    goBack() {
      // Logic to go back. If history allows, go back, else redirect to home.
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    }
  }
};
</script>

<style scoped>
.card-header {
    font-size: 1.2rem;
}
</style>
